import React, { useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate } from "react-router";
import { RoutesPaths } from "../../Router/constant";
import { useDispatch, useSelector } from "react-redux";
import { getPlanProductAction } from "../../actions/subscriptionPlan";
import { SUBSCRIPTION_MODULE_TYPE } from "../../constants";
import { getStripeSubscriptionAction, setPaymentMethodSelection } from "../../actions/stripe";
import ContentLoader from "react-content-loader";
import _ from "lodash";
import Header from "../../components/header/header";
import PlanCardList from "./PlanCardList";

export default function Products() {
  const dispatch = useDispatch();
  const { selectedCompany } = useSelector((state) => state.company);
  const navigate = useNavigate();
  const { productPlanList, loadProductPlanList, selectedPlanProductCurrentPage, } = useSelector((state) => state.subscriptionPlanProducts);
  const { control } = useForm();
  // const [activeType, setActiveType] = useState(1);

  const [page, setPage] = useState(
    selectedPlanProductCurrentPage && selectedPlanProductCurrentPage?.page
      ? selectedPlanProductCurrentPage?.page
      : 1
  );
  const [activePage, setActivePage] = useState(
    selectedPlanProductCurrentPage && selectedPlanProductCurrentPage?.page
      ? selectedPlanProductCurrentPage?.page - 1
      : 0
  );
  const limit = useWatch({ control, name: "limit" });

  useEffect(() => {
    callGetActionsOnLoad();
  }, [selectedCompany, page, limit, dispatch]);

  const callGetActionsOnLoad = () => {
    if (selectedCompany && selectedCompany?.id && page) {
      dispatch(getPlanProductAction(selectedCompany?.id, page, 50, selectedPlanProductCurrentPage));
      dispatch(setPaymentMethodSelection(null));
      dispatch(getStripeSubscriptionAction(selectedCompany?.id, 1, 2000));
    }
  };


  const planButtonTrigger = (item) => {
    if (selectedCompany?.isBuyEnabled) {
      if (item?.slug) {
        navigate(RoutesPaths.PRODUCT_PAGE.replace(":slug", item?.slug));
      }
    }
  };


  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setActivePage(selectedPage);
    setPage(selectedPage + 1);
  };

  useEffect(() => {
    // Reset activePage to 0 whenever the "limit" field changes
    setActivePage(
      selectedPlanProductCurrentPage && selectedPlanProductCurrentPage?.page
        ? selectedPlanProductCurrentPage?.page - 1
        : 0
    );
    setPage(
      selectedPlanProductCurrentPage && selectedPlanProductCurrentPage?.page
        ? selectedPlanProductCurrentPage?.page
        : 1
    );
  }, [limit, selectedCompany]);

  // const handleSegment = (id) => {
  //   setActiveType(id)
  // }
  const segmentArray = [
    { id: 1, name: "Plans" },
    { id: 6, name: "Services" },
  ]

  const renderContent = () => {
    const availablePlans = productPlanList?.filter(x => x.planType?.value === SUBSCRIPTION_MODULE_TYPE.PLAN);
    const availableBusinessPlans = productPlanList?.filter(x => x.planType?.value === SUBSCRIPTION_MODULE_TYPE.BUSINESSPLAN);
    // const availableServices = productPlanList?.filter(x => x.planType?.value === SUBSCRIPTION_MODULE_TYPE.SERVICES);
    const noPlansAvailable = !availablePlans?.length && !availableBusinessPlans?.length;
    // const noServicesAvailable = !availableServices?.length;
    return (
      <>
        {/* {activeType === SUBSCRIPTION_MODULE_TYPE.SERVICES ?
          <>
            {availableServices?.length > 0 &&
              <PlanCardList
                productPlanList={availableServices}
                planButtonTrigger={planButtonTrigger}
                name={"Services"}
                activeType={SUBSCRIPTION_MODULE_TYPE.SERVICES}
              />
            }
            {noServicesAvailable && (
              <div className="d-flex">
                <div className="d-flex flex-column justify-content-center">
                  <h6 className="text-sm table-heading productAlign">
                    No services found
                  </h6>
                </div>
              </div>
            )}
          </>
          : */}
        <div>
          {availablePlans?.length > 0 &&
            <PlanCardList
              productPlanList={availablePlans}
              planButtonTrigger={planButtonTrigger}
              name={"Company Plan"}
              activeType={SUBSCRIPTION_MODULE_TYPE.PLAN}
            />
          }
          {availableBusinessPlans?.length > 0 &&
            <PlanCardList
              productPlanList={availableBusinessPlans}
              planButtonTrigger={planButtonTrigger}
              name={"Business services"}
              activeType={SUBSCRIPTION_MODULE_TYPE.BUSINESSPLAN}
            />
          }
          {noPlansAvailable && (
            <div className="d-flex">
              <div className="d-flex flex-column justify-content-center">
                <h6 className="text-sm table-heading productAlign">
                  No plans found
                </h6>
              </div>
            </div>
          )}
        </div>
        {/* } */}
      </>
    )
  }
  return (
    <>
      <Header title="Products" subtitle="Products" />

      <div className="container-fluid minHeightVH py-4 paymentPage paddingBottomMD">
        <div className="row">
          <div className="col-md-8 order-md-1 order-1">
            <div className="paymentHeader">
              <div className="segmentHolder">
                {/* {segmentArray?.map((item, index) => (
                  <div
                    onClick={() => handleSegment(item.id)}
                    key={index}
                    className={`segment ${item.id === activeType ? "active" : ""
                      }`}>
                    <p>{item.name}</p>
                  </div>
                ))} */}
              </div>
            </div>
          </div>
        </div>
        {!loadProductPlanList ?
          renderContent() :
          <div>
            <div className="row">
              {[1, 2, 3, 4].map((item, index) => (
                <div key={index} className="col-md-4 col-lg-3 col-6">
                  <ContentLoader width={"100%"} height={164}>
                    <rect rx="5" ry="5" width={"100%"} height="164" />
                  </ContentLoader>

                  <div className="row mt-2">
                    {[1, 2, 3].map((item, index) => (
                      <div key={index} className="col-md-7">
                        <ContentLoader width={"100%"} height={20}>
                          <rect rx="5" ry="5" width={"100%"} height={50} />
                        </ContentLoader>
                      </div>
                    ))}
                  </div>
                  <div className="row mt-4">
                    <div className="col-md-12">
                      <ContentLoader width={"100%"} height={50}>
                        <rect rx="5" ry="5" width={"100%"} height={50} />
                      </ContentLoader>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>}
      </div >
    </>
  );
}
